import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/software-audit";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/software-audit")({
  head: () => buildServiceHead(seo),
  component: Page,
});
